import type { Ticket } from 'node-zendesk/clients/core/tickets'

import { useQuery } from '@fv/client-core'

import { adminFetch } from '@/utils'

export function useLoadTickets(loadId: string, enabled: boolean) {
  return useQuery(
    ['load', loadId, 'tickets'],
    async () => await adminFetch<Ticket[]>(`/loads/${loadId}/tickets`),
    {
      enabled: !!loadId && enabled,
    },
  )
}
